import React from 'react'
import {
  Grid,
  RadioGroup,
  FormControl,
  FormHelperText,
  FormControlLabel,
  Radio,
} from '@material-ui/core'
import { Controller } from 'react-hook-form'
import useStyles from './styles'

const PartnerReportSelection = ({ control, errors, clearError }) => {
  const classes = useStyles()

  return (
    <Grid item xs={12}>
      <FormControl component="fieldset" error={!!errors.reportSelected}>
        <Controller
          name="reportSelected"
          control={control}
          defaultValue="reportByAllPartners"
          as={
            <RadioGroup
              onChange={(e) => {
                clearError('reportSelected')
                return e.target.value
              }}
            >
              <FormControlLabel
                value="reportByAllPartners"
                control={<Radio classes={{ checked: classes.checked }} />}
                className={classes.radioLabel}
                label="Todos os fornecedores"
              />
              <FormControlLabel
                value="reportByPartner"
                className={classes.radioLabel}
                control={<Radio classes={{ checked: classes.checked }} />}
                label="Selecionar um fornecedor"
              />
              <FormControlLabel
                value="reportByAllAssessments"
                className={classes.radioLabel}
                control={<Radio classes={{ checked: classes.checked }} />}
                label="Todas as pré-avaliações"
              />
              <FormControlLabel
                value="reportByAssessment"
                className={classes.radioLabel}
                control={<Radio classes={{ checked: classes.checked }} />}
                label="Selecionar pré-avaliações"
              />
            </RadioGroup>
          }
        />
        {errors.reportSelected && (
          <FormHelperText>{errors.reportSelected.message}</FormHelperText>
        )}
      </FormControl>
    </Grid>
  )
}

export default PartnerReportSelection
